
import { ICapacityResponse } from '../../shared/models/capacity.model';
import { of } from 'rxjs/internal/observable/of';
import { throwError } from 'rxjs/internal/observable/throwError';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CapacityState } from './capacity.reducer';
import { FeatureKeys } from '../app.reducer';


export class CapacityAdapter {
    static toCapacity(response: ICapacityResponse) {
        const statusCode = response.status?.code;
        if (!response.status || `${statusCode}` === '200') {
            return of(response.capacity);
        } else {
            return throwError(`${statusCode || 'Unknown'} - ${response.status?.messages?.join(', ') || 'Error'}`);
        }
    }
}

export const selectCapacityFeature = createFeatureSelector<CapacityState>(FeatureKeys.CAPACITY);


/* To select the appointments loading flag in the dashboard state */
export const selectCapacityLoading = createSelector(
    selectCapacityFeature,
    (state: CapacityState) => state.loading
);

export const selectCapacity = createSelector(
    selectCapacityFeature,
    (state: CapacityState) => state.capacity
);

export const selectCapacityOverride = createSelector(
    selectCapacityFeature,
    (state: CapacityState) => state.capacityOverride
);

export const selectUpdateCapacityLoading = createSelector(
    selectCapacityFeature,
    (state: CapacityState) => state.loading
);

export const selectCurrentCapacityDate = createSelector(
    selectCapacityFeature,
    (state: CapacityState) => state.capacitySelectedDate
);

export const selectCurrentCapacity = createSelector(
    selectCapacityFeature,
    selectCurrentCapacityDate,
    (state: CapacityState) => state.capacity.find(x => x.date === state.capacitySelectedDate)
);
